import humanizeDuration from 'humanize-duration'

let humanizer
let shortHumanizer

function initGetDurationTimeUtil (params = {}) {
  let { language } = params
  if (!humanizeDuration.getSupportedLanguages().includes(language)) {
    language = 'en'
  }

  humanizer = humanizeDuration.humanizer({
    ...params,
    language
  })

  // TODO handle other languages
  shortHumanizer = humanizeDuration.humanizer({
    ...params,
    language: 'shortEn',
    languages: {
      shortEn: {
        y: () => 'y',
        mo: () => 'mo',
        w: () => 'w',
        d: () => 'd',
        h: () => 'h',
        m: () => 'm',
        s: () => 's',
        ms: () => 'ms'
      }
    }
  })
}

function getOptions (value) {
  let units
  let largest
  if (value === 60) {
    units = ['m']
  } else if (value < 120) {
    units = ['s']
  } else if (value === 3600 || value === 7200) {
    units = ['h']
  } else if (value > 3600) {
    units = [
      'h',
      'm'
    ]
    largest = 2
  } else {
    units = [
      'm',
      'h',
      's'
    ]
  }

  return {
    units,
    largest
  }
}

/**
 * Gets the humanized duration time.
 * @param {number} value duration in seconds.
 * @param {Object} [params={}]
 * @returns {string}
 */
function getDurationTimeUtil (value, params = {}) {
  if (!humanizer) {
    initGetDurationTimeUtil()
  }
  const {
    units,
    largest
  } = getOptions(value)
  return humanizer(value * 1000, {
    units,
    largest: largest || 1,
    round: true,
    ...params
  })
}

function getShortDurationTimeUtil (value, params = {}) {
  if (!humanizer) {
    initGetDurationTimeUtil()
  }
  const {
    units,
    largest
  } = getOptions(value)
  return shortHumanizer(value * 1000, {
    units,
    largest: largest || 1,
    round: true,
    ...params
  })
}

export {
  getDurationTimeUtil,
  getShortDurationTimeUtil,
  initGetDurationTimeUtil
}
